/**
 * Centralized localStorage management utility.
 * All localStorage access should go through this module.
 */

const PREFIX = 'pms_';

const storage = {
  get(key) {
    try {
      const value = localStorage.getItem(PREFIX + key);
      return value !== null ? value : localStorage.getItem(key);
    } catch {
      return null;
    }
  },

  set(key, value) {
    try {
      localStorage.setItem(PREFIX + key, value);
      // Keep legacy key for backward compatibility
      localStorage.setItem(key, value);
    } catch {
      // Storage full or unavailable
    }
  },

  remove(key) {
    try {
      localStorage.removeItem(PREFIX + key);
      localStorage.removeItem(key);
    } catch {
      // Ignore
    }
  },

  // Theme-specific helpers
  theme: {
    getLayout: () => storage.get('layout'),
    getSidebarLayout: () => storage.get('sidebar_layout'),
    getSidebarIconType: () => storage.get('sidebar_icon_type'),
    getLayoutType: () => storage.get('layout_type'),
    getMixBackground: () => storage.get('mix_background_layout'),
    getDefaultColor: () => storage.get('default_color'),
    getSecondaryColor: () => storage.get('secondary_color'),
    getAnimation: () => storage.get('animation'),
    isAuthenticated: () => storage.get('login') === 'true' || storage.get('authenticated') === 'true',

    setLayout: (v) => storage.set('layout', v),
    setSidebarLayout: (v) => storage.set('sidebar_layout', v),
    setSidebarIconType: (v) => storage.set('sidebar_icon_type', v),
    setLayoutType: (v) => storage.set('layout_type', v),
    setMixBackground: (v) => storage.set('mix_background_layout', v),
    setDefaultColor: (v) => storage.set('default_color', v),
    setSecondaryColor: (v) => storage.set('secondary_color', v),
    setAnimation: (v) => storage.set('animation', v),
    setAuthenticated: (v) => {
      storage.set('login', v ? 'true' : 'false');
      storage.set('authenticated', v ? 'true' : 'false');
    },
  },
};

export default storage;
